<template>
    <div class="lat-menu" :class="{active_menu:menu_activo == true}">
        <div class="container-empresa">
            <img src="../assets/logo.png" alt="">
        </div>
        <div class="centainer-items">
            <div class="item" v-for="(item, index) of items" @click="navegarPagina(item.path)" :class="{active:route.path ===item.path}"  :key="index">
                <li :class="item.icon"></li>
                <p class="title" >{{ item.name }}</p>
            </div>
        </div>
    </div>
    <div class="btn-menu" @click="AccionarMenu"><li class="pi pi-bars"></li></div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute()
const menu_activo = ref(false);

const items = ref([
    {
        name:"Inicio",
        icon:"pi pi-home",
        path:"/dashboard"
    },
    {
        name:"Clientes",
        icon:"pi pi-building",
        path:"/clientes"
    },
    {
        name:"Prospectos",
        icon:"pi pi-users",
        path:"/prospectos"
    },
    {
        name:"Salir",
        icon:"pi pi-sign-out",
        path:"/"
    }
])

const AccionarMenu = ()=>{
    menu_activo.value = !menu_activo.value;
}

const navegarPagina =(path)=>{
    if (route.path !== path) {
        router.push(path)
    }
}

</script>


<style scoped>

.btn-menu
{
    width: 20px;
    height: 20px;
    top: 10px;
    position: fixed;
    right: 5px;
    font-size: 20px;
    display: none;
}

.item{
    width: 100%;
    display: flex;
    padding: 12px;
    margin-top: 5px;
    cursor: pointer;
    border-radius: 10px;
}
.active
{
    background-color: #E8F2FC;
    color: rgb(0, 92, 192);
}
.item:hover
{
    background: rgb(74, 99, 117);
    border-radius: 10px;
    transition: all .45s;
    color: white;
}
.item li{
    margin-top: 4px;
    margin-right: 12px;
}
.item .title{
    font-size: 1em;
    text-align: center;
    margin-left: 12px;
}
.container-empresa
{
    width: 90%;
    margin:auto;
}
.container-empresa img{
    width: 100;
    height: 80px;
    display: block;
    margin: 20px auto;
}
.centainer-items{
    width: 95%;
    margin: 30px auto;
    height: 80vh;
    overflow-y: scroll;
}
.centainer-items::-webkit-scrollbar {
    display: none;               
}

.lat-menu {
    width: 220px;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: white;
    box-shadow: 0 4px 4px silver;
    transform: translateX(0); /* visible */
    transition: transform .4s ease;
    z-index: 1;
}

/* Mobile: oculto por defecto */
@media (max-width: 1024px) {
    .lat-menu {
        width: 80%;
        transform: translateX(-100%);
    }

    .lat-menu.active_menu {
        transform: translateX(0);
    }
    
    .btn-menu{
        display: block;
    }
}

@media (prefers-color-scheme: dark) {
    .lat-menu {
        background: rgb(0, 0, 0);
        box-shadow: 0px 4px 5px rgb(0, 0, 0);
    }
}

</style>